module.exports = __webpack_public_path__ + "img/canbadge-round-57mm-momo_line.b2c6da2c.png";